export enum SentryStorage {
    SESSION_ID = "sentry.sessionId",
}
